module.exports = __webpack_public_path__ + "static/android-chrome-512x512-f59769f0320f64ed338b0e7c0037aacc.png";